import React from 'react';
import { ContentSingularData } from '../../_data/ContentSingularData';
import './Audio.css';

/**
 * Shows an embedded audio.
 *
 * Last Modified
 * Diandre Sabale
 * Oct. 11, 2022
 */
export const Audio: React.FC<ContentSingularData> = ({
	audio_audioLink
}) => {
	if (!audio_audioLink) {
		return <></>
	}

	return <div className="centered wi-content-wrapper">
		<audio src={audio_audioLink} controls>
			Your browser does not support the audio element.
    	</audio>
	</div>
}
